<template>
  <div v-if="showDevelopment">
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!--<template v-if="!loading">-->
    <template>
      <FourLayout>
        <template v-slot:two>
          <InsightHex :number="sensorCount" title="Sensors"
                      subtext="In This Building"></InsightHex>
        </template>
        <template v-slot:three>
          <InsightHex :number="onlineSensors" title="Sensors Offline" subtext="Right Now"></InsightHex>
        </template>
        <!--
        <template v-slot:three>
          <InsightHex :number="0" title="Errors" subtext="This Week"></InsightHex>
        </template>
        <template v-slot:four>
          <InsightHex :number="0" title="Sensors Reset" subtext="This Week"></InsightHex>
        </template>
        -->
      </FourLayout>
      <SensorTable v-if="selectedBuildingSensorReadings !== []" :sensorData="latestSensorTableData" link></SensorTable>
      <div>
        <v-row v-if="debug">
          <v-col cols="12">
            <v-card>
              <v-card-title>Sensor Debug</v-card-title>
              <p>Table data {{ latestSensorTableData }}</p>
              <p>Raw data {{ selectedBuildingSensorReadings }} </p>
              <p>Building {{ selectedBuildingInfo }}</p>
            </v-card>
          </v-col>
        </v-row>
      </div>

    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import InsightHex from '../components/InsightHex'
import SensorTable from '../components/SensorTable'
import FourLayout from '../components/FourLayout'
import { getSensorLocationInfoForSensorLocationId } from '@/lib/buildingDataLookup'

function generateSensorTableData (building, selectedBuildingSensorReadings) {
  if (!building || !selectedBuildingSensorReadings) {
    return []
  }

  return selectedBuildingSensorReadings.map(sensorReading => {
    let sensorLocationInfo = getSensorLocationInfoForSensorLocationId(building, sensorReading.sensorlocation)
    console.log('Sensor reading', sensorReading)
    console.log('******* selected location info', sensorLocationInfo)

    const {
      physicalsensorid,
      occupancy,
      temperature,
      noise,
      co2,
      co2hq,
      co2bme,
      voc,
      rawgasbme,
      aqi1,
      aqi2,
      humid,
      pressure,
      lux,
      internalhumid,
      internaltemperature,
      bearing,
      // eslint-disable-next-line camelcase
      time_epoch_milli,
      sensorlocationid,
      deviceid
    } = sensorReading.detail
    return {
      name: sensorLocationInfo.name,
      loraAddress: physicalsensorid,
      link: `sensor/${deviceid}`,
      mapMarkerLabel: sensorLocationInfo.mapmarkerlabel,
      roomName: sensorLocationInfo.roomname,
      sensor: {
        occupancy,
        temperature,
        noise,
        co2,
        co2hq,
        co2bme,
        voc,
        rawgasbme,
        aqi1,
        aqi2,
        humid,
        pressure,
        lux,
        internalhumid,
        internaltemperature,
        bearing,
        time_epoch_milli,
        sensorlocationid,
        deviceid
      }
    }
  })
}

export default {
  name: 'operations',
  components: {
    InsightHex,
    SensorTable,
    FourLayout
  },
  data: () => {
    return {
      debug: false,
      loading: false
    }
  },
  computed: mapState({
    buildings: function (state) {
      return state.building.buildings
    },
    selectedBuildingInfo: function (state) {
      return state.building.selectedBuildingInfo
    },
    selectedBuilding: function (state) {
      return state.building.selectedBuilding
    },
    selectedBuildingSensorReadings: function (state) {
      return state.building.selectedBuildingSensorReadings
    },
    onlineSensors: function (state) {
      return '?'
    },
    showDevelopment: function (state) {
      return state.auth.isDevelopment
    },
    sensorCount: function (state) {
      if (this.selectedBuildingSensorReadings === null) {
        return '-'
      }
      return this.selectedBuildingSensorReadings.length
    },
    latestSensorTableData: function (state) {
      return generateSensorTableData(this.selectedBuildingInfo, this.selectedBuildingSensorReadings)
    }
  }),
  methods: {}
}
</script>

<!--

      co2hq co2bme voc rawgasbme aqi1 aqi2 humid pressure lux internalhumid internaltemperature

-->
